import $ from 'jquery';
import 'styleguide/styleguide';

import './header';
import './footer';



import './global';
import 'modules/loyalty';
import 'modules/ntf';
import 'modules/product-rec-tracking';

$(window).on('load', function (){
  window.windowIsLoaded = true;
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/index.js